// extracted by mini-css-extract-plugin
module.exports = {"image":"c0","image-placeholder":"c1","imagePlaceholder":"c1"};